<div class="row">
    <div class="col-md-12">
        <div class="card-box">
            <div class="pull-in">
                <div role="application" class="wizard clearfix" id="steps-uid-0">
                    <div class="steps clearfix">
                        <ul role="tablist">
                            <li role="tab" class="first " :class="{'disabled': step !== (index+1), 'current': step === (index+1)}"
                                aria-disabled="false" aria-selected="true"
                                v-for="(heading, index) in wizardHeadings">
                                <a id="steps-uid-0-t-0" href="javascript: void(0);" aria-controls="steps-uid-0-p-0">
                                    <span class="current-info audible">current step: </span><span class="number">{{index+1}}.</span> {{heading}}
                                </a>
                            </li>
                            
                        </ul>
                    </div>
                    <div class="wizard-content">
                        <slot></slot>
                    </div>
                    <div class="actions clearfix">
                        <ul>
                            <li v-if="step < wizardHeadings.length">
                                <button class="btn btn-primary" @click="previousStep" :disabled="step === 1 || isSubmitting">Previous</button>
                            </li>
                            <li v-if="step < wizardHeadings.length">
                                <button class="btn btn-primary" @click="beginSubmission" :disabled="step === wizardHeadings.length || isSubmitting || !moveToNextPanel">Next</button>
                            </li>
                            <li v-if="step === wizardHeadings.length && showDoneButton">
                                <button class="btn btn-primary" @click="done" :disabled="isSubmitting">Done</button>
                            </li>
                        </ul>
                    </div>
                </div>


            </div> <!-- end .pull-in-->

        </div> <!-- end card-box -->
    </div> <!-- end col -->
</div>
